import Select from 'components/Inputs/Select';
import MainButton from 'components/MainButton';
import { fireTypeOptions } from 'models/FireModel';
import React from 'react';
import { FormattedMessage, injectIntl, WrappedComponentProps } from 'react-intl';
interface IntegratedFireInputProps {
  input: string;
  fireType: string;
  fireConfigId: number | string;
  fireConfigs: Array<{ id: number; strategy_setting_type?: string; default_config?: boolean }>;
  onInputChange: (value: string) => void;
  onFireTypeChange: (value: string) => void;
  onFireConfigChange: (value: string) => void;
  onSubmit: () => void;
  loading?: boolean;
}

const IntegratedFireInput: React.FC<IntegratedFireInputProps & WrappedComponentProps> = ({
  input,
  fireType,
  fireConfigId,
  fireConfigs,
  onInputChange,
  onFireTypeChange,
  onFireConfigChange,
  onSubmit,
  loading = false,
  intl
}) => {
  return (
    <div className="integrated-fire-input">
      <div className="integrated-fire-input__container">
        <textarea
          value={input}
          onChange={(e) => onInputChange(e.target.value)}
          placeholder={intl.formatMessage({ id: 'fire_input_placeholder' })}
          className="integrated-fire-input__textarea"
          rows={4}
        />

        <div className="integrated-fire-input__controls">
          <div className="integrated-fire-input__selects">
            <Select
              name="fire_type"
              value={fireType}
              onChange={(e) => onFireTypeChange(e.target.value)}
              fireFont={true}
            >
              {fireTypeOptions.filter((type) => type !== 'brainstorming').map((type) => (
                <option key={type} value={type}>
                  {type.charAt(0).toUpperCase() + type.slice(1)}
                </option>
              ))}
            </Select>

            <Select
              name="fire_config"
              value={String(fireConfigId)}
              onChange={(e) => onFireConfigChange(e.target.value)}
              fireFont={true}
            >
              {fireConfigs.map((config) => (
                <option key={config.id} value={config.id}>
                  {config.strategy_setting_type || ''}
                </option>
              ))}
            </Select>
          </div>

          <MainButton onClick={onSubmit} disabled={loading} small={true}>
            <FormattedMessage id="Fire submit" />
          </MainButton>
        </div>
      </div>
    </div>
  );
};

export default injectIntl(IntegratedFireInput);